import gsap from 'gsap';
import { EFAULT } from 'constants';

class Error {
  constructor(el) {
    this.ctxEl = el;
    this.ctx = {
      el: el || window,
      width: el.getBoundingClientRect().width,
      height: el.getBoundingClientRect().height,
      d: Math.sqrt(Math.pow(el.getBoundingClientRect().width, 2) + Math.pow(el.getBoundingClientRect().height, 2)),
    }

    const textBase = el.querySelector('[data-dimension]');
    this.text = {
      el: textBase,
      width: textBase.getBoundingClientRect().width,
      height: textBase.getBoundingClientRect().height - 20,
    }

    this.paragraphs = [];
    this.handleResize = () => this.resize();

    gsap.set(this.ctx, { autoAlpha: 0 });
  }

  init() {
    this.setCalc();
    this.createNodes();
    this.animate('in');

    this.addEvents();
  }

  addEvents() {
    window.addEventListener('resize', this.handleResize);
  }

  setCalc() {
    const totDim = this.ctx.width + this.ctx.height;
    this.pNumber = Math.ceil(totDim / this.text.height);
  }

  createNodes() {
    for (let i = 0; i < this.pNumber + 1; i++) {
      const index = i;
      const p = document.createElement('p');
      p.className = 'error-text';

      this.positionNodes(p, i);
    }

    this.calcContent();
  }

  positionNodes(p, i) {
    const el = p;
    const index = i;
    const bottom = Math.ceil((index * this.text.height) - 100);
    const condition = bottom < this.ctx.height;

    if (condition) {
      this.changeCateto = false;
      this.lastValid = { bottom, index };
    } else {
      this.changeCateto = true;
    }

    const bot = condition ? bottom : -100;
    el.style.bottom = `${bot}px`;

    const offsetCateto = condition ? 0 : Math.ceil((index - this.lastValid.index) * this.text.height);
    el.style.left = `${offsetCateto}px`;

    this.paragraphs.push({ elementHTML: el, index: i, bottom: bot, offset: offsetCateto });
  }

  workArray() {
    const arrayA = this.paragraphs.filter(el => el.bottom > 0).reverse();
    const arrayB = this.paragraphs.filter(el => el.bottom < 0);

    this.paragraphs = arrayA.concat(arrayB);
  }

  calcContent() {
    this.workArray();

    this.paragraphs.forEach((el) => {
      const c = el.offset === 0 ? Math.ceil(this.ctx.height - el.bottom) : Math.ceil(this.ctx.width - el.offset);
      const cateto = Math.min(c, Math.ceil(this.ctx.height));
      const d = Math.ceil(cateto * Math.sqrt(2));
      const numbText = Math.ceil(d / this.text.width);

      let content = '';
      for (let i = 0; i < numbText; i++) {
        content += '404 ';
      }

      el.content = content;

      const node = document.createTextNode(content);

      el.elementHTML.appendChild(node);
      this.ctx.el.appendChild(el.elementHTML);
    });;
  }

  animate(dir, callback = () => {}) {
    gsap.to(this.ctx, 0.4, {
      autoAlpha: 1,
      onComplete: callback,
    });
  }

  resize() {
    this.ctx.width = this.ctxEl.getBoundingClientRect().width;
    this.ctx.height = this.ctxEl.getBoundingClientRect().height;
    this.ctx.d = Math.sqrt(Math.pow(this.ctxEl.getBoundingClientRect().width, 2) + Math.pow(this.ctxEl.getBoundingClientRect().height, 2));

    this.paragraphs.forEach((el) => {
      el.elementHTML.remove();
    });
    this.paragraphs = [];
    this.setCalc();
    this.createNodes();
  }

  destroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}

export default Error;


// WEBPACK FOOTER //
// ./src/scripts/error.js